import React, { useEffect, useState } from "react";
import DropdownSchoolYear from "../../../unicomponents/Dropdowns/DropdownSchoolYear";
import { useUIContext } from "../../../context/UIContext";
import useVariousStudentRecords from "../../../hooks/useVariousStudentRecords";
import {
  findDuplicateData,
  generateRegistrationRows,
  trimObjectValues,
} from "../../../util/dealingArrObj";
import DropdownHierarchyOne from "../../../unicomponents/Dropdowns/DropdownHierarchyOne";
import DropdownHierarchyTwo from "../../../unicomponents/Dropdowns/DropdownHierarchyTwo";
import DropdownHierarchyThree from "../../../unicomponents/Dropdowns/DropdownHierarchyThree";
import DropdownUniqueUsersInDisplayData from "../../../unicomponents/Dropdowns/DropdownUniqueUsersInDisplayData";
import useRegistrationInfo from "../../../hooks/useRegistrationInfo";
import AddInputsRow from "../../../unicomponents/GeneratedByData/AddInputsRow";
import SaveInputsTable from "../../../unicomponents/GeneratedByData/SaveInputsTable";
import { useAuthContext } from "../../../context/AuthContext";
import { checkHrteachers } from "../../../util/checkPermissions";
import SimpleAlertMessageBlock from "../../../unicomponents/SimpleAlertMessageBlock";
import { useTranslation } from "react-i18next";
import useUsers from "../../../hooks/useUsers";

/*
상단에 재적 dropdown + user의 수업 dropdown
하단에 기록할 내용 (various_record_inputs 에서 가져옴)
그 하단에 테이블로 저장한 것이 나옴 (various_record_inputs 에서 가져옴)
수정, 삭제 가능
*/

/*
다른 것 (독서기록 등)과 가장 큰 차이점은 중복 저장이 가능한 것이다. allow_duplicate를 true로 넣어야 한다.
그래서 중복 검사도 건너 뛴다.
*/

export default function CoommiPep({
  settingData,
  inputData,
  schoolId,
  inputQueryConditions,
  hrTeachersData,
}) {
  const { t } = useTranslation();
  const [filters, setFilters] = useState({
    schoolYear: null,
    schoolYearId: "",
    hierarchyOneId: "",
    hierarchyTwoId: "",
    hierarchyThreeId: "",
    filters: "",
    organPathForSort: "N/A",
    selectedStudent: "",
    selectedTeacher: "",
  });

  const [queryConditions, setQueryConditions] = useState({
    schoolid: schoolId,
    school_year_id: "",
    record_list_id: inputQueryConditions?.record_list_id,
  });

  const [dataToCreate, setDataToCreate] = useState({});
  const [studentList, setStudentList] = useState([]);
  const [validateInput, setValidateInput] = useState({});
  const [dataToSave, setDataToSave] = useState([]);
  const [allStudentData, setAllStudentData] = useState([]);
  const [savedRows, setSavedRows] = useState([]);
  const [confirmDelete, setConfirmDelete] = useState([]);
  const [displayMapping, setDisplayMapping] = useState({});
  const [savedBulk, setSavedBulk] = useState(false);

  const {
    registrationInfoQuery: { data: registrationInfoData },
  } = useRegistrationInfo({ schoolid: schoolId });

  const {
    getVariousStudentDataWithRegi,
    createOrUpdateVariousStudentRecords,
    deleteVariousStudentRecordOne,
    createOrUpdateVariousStudentRecordsBulk,
  } = useVariousStudentRecords(queryConditions);

  const {
    usersQuery: { data: teacherData },
  } = useUsers({ schoolid: schoolId }, { role: "teacher", status: 1 });

  const { setIsLoadingModal, handleToastCenterTop } = useUIContext();
  const { user, hasPermission } = useAuthContext();

  useEffect(() => {
    let initialSchoolYear = null;
    let initialSchoolYearId = null;

    if (
      filters.schoolYear === null &&
      registrationInfoData &&
      settingData &&
      settingData.length > 0
    ) {
      const initialData = settingData.sort(
        (a, b) => b.school_year - a.school_year,
      )[0];

      initialSchoolYear = initialData.school_year;
      initialSchoolYearId = initialData.id;
      setFilters((filters) => ({
        ...filters,
        schoolYear: initialSchoolYear,
        schoolYearId: initialSchoolYearId,
      }));

      setQueryConditions((prev) => ({
        ...prev,
        school_year_id: initialSchoolYearId,
        school_year: initialSchoolYear,
      }));

      if (initialSchoolYear) {
        //학생 리스트
        const sortedRows = generateRegistrationRows(
          registrationInfoData,
          settingData,
          initialSchoolYear,
          filters.organPathForSort,
        );
        // console.log("sortedRows", sortedRows);
        setStudentList(sortedRows);
      }
    } else {
      //rows 데이터처리
      if (registrationInfoData && settingData) {
        // console.log("registrationInfoData", registrationInfoData);
        // console.log("filters", filters);

        const sortedRows = generateRegistrationRows(
          registrationInfoData,
          settingData,
          filters.schoolYear,
          filters.organPathForSort,
        );
        // console.log("sortedRows2", sortedRows);
        setStudentList(sortedRows);
      }
    }
  }, [
    filters,
    filters.organPathForSort,
    filters.schoolYear,
    registrationInfoData,
    settingData,
  ]);

  useEffect(() => {
    if (hrTeachersData && filters.schoolYear)
      if (checkHrteachers(hrTeachersData, "", filters.schoolYear)) {
        const thisYearData = hrTeachersData.filter(
          (r) => r.schoolYear === filters.schoolYear,
        );
        const splited = thisYearData[0].organization_path.split("/");

        setFilters((filters) => ({
          ...filters,
          hierarchyOneId: splited[2],
          hierarchyTwoId: splited[3],
          hierarchyThreeId: splited[4],
          organPathForSort: thisYearData[0].organization_path,
        }));

        // 담임교사 데이터가 있을 때 해당 경로로 필터링
        filterDataLocally(thisYearData[0].organization_path);
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters.schoolYear, hrTeachersData]);

  useEffect(() => {
    if (teacherData && user) {
      // console.log("teacherData", teacherData);
      if (user.role === "teacher") {
        setFilters((filters) => ({
          ...filters,
          selectedTeacher: user.username,
        }));
      }
    }
  }, [user, teacherData]);

  // 클라이언트 측 필터링 함수 추가
  const filterDataLocally = (organPath) => {
    if (!allStudentData || allStudentData.length === 0) return;
    const filteredData = allStudentData.filter((r) =>
      r.organization_path.startsWith(organPath),
    );

    setDataToSave(filteredData);
  };

  function queryVariousStudentDataWithRegi(forWhere, organPath = "") {
    getVariousStudentDataWithRegi.mutate(forWhere, {
      onSuccess: (data) => {
        if (settingData) {
          const settingMap = settingData.reduce((map, setting) => {
            map[setting.id] = setting.group_name;
            return map;
          }, {});

          const updatedData = data.map((studentData) => {
            const pathParts = studentData.organization_path.split("/");
            const stageId = pathParts[2]; // 과정
            const yearId = pathParts[3]; // 학년
            const classId = pathParts[4]; // 반

            const groupNameOne = settingMap[stageId];
            const groupNameTwo = settingMap[yearId];
            const groupNameThree = settingMap[classId];

            return {
              ...studentData,
              hierarchyOne: groupNameOne,
              hierarchyTwo: groupNameTwo,
              hierarchyThree: groupNameThree,
            };
          });

          // 전체 데이터 저장
          setAllStudentData(updatedData);

          // 현재 선택된 경로에 맞게 필터링
          if (organPath) {
            const filteredData = updatedData.filter((r) =>
              r.organization_path.startsWith(organPath),
            );
            setDataToSave(filteredData);
          } else {
            setDataToSave(updatedData);
          }
        }
      },
      onError: (error) => {
        console.error(error); // 일단 콘솔에 에러를 출력합니다.
        console.error("위와 같은 에러가 났으니 고치삼");
        alert(t("common.messages.errorAlert") + error.message);
        return "";
      },
    });
  }

  const handleDropdownChange = (e) => {
    const { name, value } = e.target;
    const selectedOptionText = e.target.selectedOptions[0].text;
    const dataName = e.target.selectedOptions[0].getAttribute("data-name");
    let organPath = "";
    if (!dataName) {
      // 기존 경로에서 마지막 부분만 제거
      if (filters.organPathForSort && filters.organPathForSort !== "N/A") {
        const pathParts = filters.organPathForSort.split("/");
        organPath = pathParts.slice(0, -1).join("/");
      } else {
        organPath = "N/A";
      }
    } else {
      organPath = dataName + "/" + value;
    }

    // console.log("dataToCreate", dataToCreate);

    // console.log("organPath", organPath);
    if (name === "0") {
      setFilters((filters) => ({
        ...filters,
        schoolYear: selectedOptionText,
        schoolYearId: value,
        hierarchyOneId: "",
        organPathForSort: "N/A",
        selectedStudent: "",
      }));

      const newQueryConditions = {
        ...queryConditions,
        school_year_id: value,
        school_year: selectedOptionText,
      };

      setQueryConditions(newQueryConditions);
      setDataToSave([]);

      // 학년도 변경 시에만 서버에서 데이터 가져오기
      queryVariousStudentDataWithRegi(newQueryConditions, "");
    }

    if (name === "1") {
      setFilters((filters) => ({
        ...filters,
        hierarchyOneId: value,
        hierarchyTwoId: "",
        hierarchyThreeId: "",
        organPathForSort: organPath,
        selectedStudent: "",
      }));

      if (allStudentData.length > 0) {
        // 클라이언트 측 필터링
        filterDataLocally(organPath);
      } else {
        // 초기 마운트 시 데이터 로드
        queryVariousStudentDataWithRegi(
          { ...queryConditions, school_year_id: filters.schoolYearId },
          organPath,
        );
      }
    }

    if (name === "2") {
      setFilters((filters) => ({
        ...filters,
        hierarchyTwoId: value,
        hierarchyThreeId: "",
        organPathForSort: organPath,
        selectedStudent: "",
      }));

      // 클라이언트 측 필터링
      filterDataLocally(organPath);
    }

    if (name === "3") {
      setFilters((filters) => ({
        ...filters,
        hierarchyThreeId: value,
        organPathForSort: organPath,
        selectedStudent: "",
      }));

      // 클라이언트 측 필터링
      filterDataLocally(organPath);
    }

    if (name === "students") {
      setFilters((filters) => ({
        ...filters,
        selectedStudent: value,
      }));
    }

    if (name === "teacher") {
      setFilters((filters) => ({
        ...filters,
        selectedTeacher: value,
      }));

      setDataToCreate((pre) => ({ ...pre, teacher: value }));

      setDisplayMapping((pre) => ({ ...pre, teacher: selectedOptionText }));
    }
  };

  const handleCreateInputChange = (e) => {
    const { name, value } = e.target;
    setDataToCreate((pre) => ({ ...pre, [name]: value }));
  };

  const handleCreateAction = (e) => {
    e.preventDefault();
    if (Object.keys(dataToCreate).length < 1) {
      handleToastCenterTop(t("teacher.schoolLifeRecords.nothingToSave"));
      return;
    }

    if (filters.selectedStudent === "") {
      handleToastCenterTop(t("common.messages.selectStudent"));
      setValidateInput((prev) => ({ ...prev, user: true }));
      return;
    } else {
      setValidateInput((prev) => ({ ...prev, user: false }));
    }

    if (filters.selectedTeacher === "") {
      handleToastCenterTop("관찰자를 선택해주세요.");
      setValidateInput((prev) => ({ ...prev, teacher: true }));
      return;
    } else {
      setValidateInput((prev) => ({ ...prev, teacher: false }));
    }

    const trimmedData = trimObjectValues(dataToCreate);

    const toSave = {
      schoolid: schoolId,
      school_year_id: filters.schoolYearId,
      record_list_id: inputQueryConditions?.record_list_id,
      group: filters.subjectName,
      username: filters.selectedStudent,
      value_object: trimmedData,
      allow_duplicate: true,
    };

    if (!toSave.allow_duplicate) {
      const keys = [
        "schoolid",
        "school_year_id",
        "record_list_id",
        "group",
        "username",
      ];

      const isDuplicate = findDuplicateData(dataToSave, toSave, keys);

      if (isDuplicate) {
        handleToastCenterTop(t("teacher.schoolLifeRecords.duplicateData"));
        return;
      } else {
        console.log("중복된 데이터가 없습니다.");
      }
    }
    if (
      toSave &&
      !hasPermission(
        null,
        "can_create",
        checkHrteachers(hrTeachersData, toSave.username, filters.schoolYear),
      )
    ) {
      handleToastCenterTop(
        t("common.messages.homeroomTeacherOnly") ||
          "학생의 담임과 권한이 있는 사람만 저장할 수 있습니다.",
      );
      return;
    }

    setIsLoadingModal(true);
    createOrUpdateVariousStudentRecords.mutate(toSave, {
      onSuccess: (successMessage) => {
        setIsLoadingModal(false);

        queryVariousStudentDataWithRegi(
          queryConditions,
          filters.organPathForSort,
        );
      },
      onError: (error) => {
        setIsLoadingModal(false);
        console.error(error); // 일단 콘솔에 에러를 출력합니다.
        console.error("위와 같은 에러가 났으니 고치삼");
        alert(t("common.messages.errorAlert") + error.message);
      },
    });
  };

  const handleSaveState = (e, username, record_id) => {
    let value = e.target.value;
    let name = e.target.name;

    setDataToSave((prevData) => {
      const existingItem = prevData.find((item) => item.id === record_id);

      if (existingItem) {
        let updatedValueObject = {
          ...existingItem.value_object,
          [name]: value,
        };

        return prevData.map((item) =>
          item.id === record_id
            ? {
                ...item,
                value_object: updatedValueObject,
                isModified: true,
              }
            : item,
        );
      } else {
        let valueObject = { [name]: value };
        return [
          ...prevData,
          {
            schoolid: schoolId,
            school_year_id: filters.schoolYearId, // 적절한 기본값을 설정합니다.
            record_list_id: inputQueryConditions?.record_list_id,
            group: filters.group, // 적절한 기본값을 설정합니다.
            username,
            value_object: valueObject,
            isModified: true,
            allow_duplicate: true,
            // 기본값을 설정합니다. 필요에 따라 다른 기본값을 설정할 수 있습니다.
          },
        ];
      }
    });
  };

  const handleSaveClick = (row) => {
    // console.log("row", row);
    // console.log("dataToSave", dataToSave);

    const trimmedDataToSave = dataToSave.map((item) => {
      const trimmedValueObject = Object.fromEntries(
        Object.entries(item.value_object).map(([key, value]) => [
          key,
          typeof value === "string" ? value.trim() : value,
        ]),
      );
      return { ...item, value_object: trimmedValueObject };
    });

    const toSave = trimmedDataToSave.filter((r) => r.id === row.id);

    // console.log("toSave.isModified", toSave.isModified);

    if (toSave.length < 1) {
      handleToastCenterTop(t("common.messages.notModifed"));

      return;
    }

    if (!toSave[0].isModified) {
      // 변경사항이 없는 경우, 제출을 건너뜁니다.
      console.log("건너뛰기");
      handleToastCenterTop(t("common.messages.notModifed"));
      return;
    }

    if (
      toSave[0] &&
      !hasPermission(
        null,
        "can_update",
        checkHrteachers(hrTeachersData, toSave[0].username, filters.schoolYear),
      )
    ) {
      handleToastCenterTop(t("common.messages.hoomroomTeacherModifyOnly"));
      return;
    }

    setIsLoadingModal(true);
    createOrUpdateVariousStudentRecords.mutate(toSave[0], {
      onSuccess: (successMessage) => {
        setIsLoadingModal(false);
        setSavedRows((prev) => [...prev, toSave[0].id]);
        setTimeout(() => {
          setSavedRows([]);
        }, 1000);

        // 성공적으로 제출 후, 해당 데이터 세트의 isModified 상태를 초기화합니다.
        setDataToSave((currentDataSets) =>
          currentDataSets.map((dataSet) =>
            dataSet.id === toSave[0].id
              ? { ...dataSet, isModified: false }
              : dataSet,
          ),
        );

        // 전체 데이터도 업데이트
        setAllStudentData((currentAllData) =>
          currentAllData.map((dataSet) =>
            dataSet.id === toSave[0].id
              ? { ...dataSet, ...toSave[0], isModified: false }
              : dataSet,
          ),
        );
      },
      onError: (error) => {
        setIsLoadingModal(false);
        console.error(error); // 일단 콘솔에 에러를 출력합니다.
        console.error("위와 같은 에러가 났으니 고치삼");
        alert(t("common.messages.errorAlert") + error.message);
      },
    });
  };

  const handleSaveAll = () => {
    const trimmedDataToSave = dataToSave.map((item) => {
      const trimmedValueObject = Object.fromEntries(
        Object.entries(item.value_object).map(([key, value]) => [
          key,
          typeof value === "string" ? value.trim() : value,
        ]),
      );
      return { ...item, value_object: trimmedValueObject };
    });

    const modifiedData = trimmedDataToSave.filter((r) => r.isModified === true);
    if (modifiedData.length < 1) {
      // 변경사항이 없는 경우, 제출을 건너뜁니다.
      console.log("건너뛰기");
      handleToastCenterTop(t("common.messages.notModifed"));
      return;
    }
    // console.log("dataToSave:", dataToSave);
    // console.log("trimmedDataToSave:", trimmedDataToSave);
    // console.log("modifiedData:", modifiedData);

    if (
      modifiedData[0] &&
      !hasPermission(
        null,
        "can_create",
        checkHrteachers(
          hrTeachersData,
          modifiedData[0].username,
          filters.schoolYear,
        ),
      )
    ) {
      handleToastCenterTop(
        t("common.messages.homeroomTeacherOnly") ||
          "학생의 담임과 권한이 있는 사람만 저장할 수 있습니다.",
      );
      return;
    }

    setIsLoadingModal(true);
    createOrUpdateVariousStudentRecordsBulk.mutate(modifiedData, {
      onSuccess: (successMessage) => {
        console.log(successMessage);
        setIsLoadingModal(false);
        setSavedBulk(true);
        setTimeout(() => {
          setSavedBulk(false);
        }, 1000);

        // 성공적으로 제출 후, 해당 데이터 세트의 isModified 상태를 초기화합니다.
        setDataToSave((currentDataSets) =>
          currentDataSets.map((data) =>
            data.isModified === true ? { ...data, isModified: false } : data,
          ),
        );
      },
      onError: (error) => {
        setIsLoadingModal(false);
        console.error(error); // 일단 콘솔에 에러를 출력합니다.
        console.error("위와 같은 에러가 났으니 고치삼");
        alert(t("common.messages.errorAlert") + error.message);
      },
    });
  };

  // 삭제 관련
  const handleConfirmDelete = (row) => {
    setConfirmDelete((prev) => [...prev, row.id]);
  };

  const handleCancelDelete = () => {
    setConfirmDelete([]);
  };

  const handleDelete = (row) => {
    const id = row.id;

    if (
      row.username &&
      !hasPermission(
        null,
        "can_delete",
        checkHrteachers(hrTeachersData, row.username, filters.schoolYear),
      )
    ) {
      handleToastCenterTop(t("common.messages.homeroomTeacherDeleteOnly"));
      return;
    }
    setIsLoadingModal(true);
    deleteVariousStudentRecordOne.mutate(id, {
      onSuccess: (successMessage) => {
        console.log(successMessage);
        setIsLoadingModal(false);
        setConfirmDelete([]);

        // 삭제 후 클라이언트 측 데이터 업데이트
        setAllStudentData((prevData) =>
          prevData.filter((item) => item.id !== id),
        );
        setDataToSave((prevData) => prevData.filter((item) => item.id !== id));
      },
      onError: (error) => {
        setIsLoadingModal(false);
        setConfirmDelete([]);
        console.error(error); // 일단 콘솔에 에러를 출력합니다.
        console.error("위와 같은 에러가 났으니 고치삼");
        alert(t("common.messages.errorAlert") + error.message);
      },
    });
  };

  return (
    <>
      <div className="row mt-3">
        <div className="col-auto">
          <h3 className="fw-bold">관찰기록</h3>
        </div>
        <div className="col">
          <DropdownSchoolYear
            settingData={settingData}
            handleDropdownChange={handleDropdownChange}
            schoolYearId={filters.schoolYearId}
            allYears={false}
          />
        </div>
        <div className="col">
          <DropdownHierarchyOne
            settingData={settingData}
            handleDropdownChange={handleDropdownChange}
            schoolYear={filters.schoolYear}
            hierarchyOneId={filters.hierarchyOneId}
          />
        </div>
        <div className="col">
          <DropdownHierarchyTwo
            settingData={settingData}
            handleDropdownChange={handleDropdownChange}
            schoolYear={filters.schoolYear}
            hierarchyOneId={filters.hierarchyOneId}
            hierarchyTwoId={filters.hierarchyTwoId}
          />
        </div>
        <div className="col">
          <DropdownHierarchyThree
            settingData={settingData}
            handleDropdownChange={handleDropdownChange}
            schoolYear={filters.schoolYear}
            hierarchyTwoId={filters.hierarchyTwoId}
            hierarchyThreeId={filters.hierarchyThreeId}
          />
        </div>
        <div className="col">
          <DropdownUniqueUsersInDisplayData
            displayData={studentList}
            displayKey={"fullname"}
            valueKey={"username"}
            filters={{ organization_path: filters.organPathForSort }}
            uniqueKey={"username"}
            sortKey={"studentno"}
            isDesc={false}
            handleDropdownChange={handleDropdownChange}
            selectedUser={filters.selectedStudent}
            selectName={"students"}
            styleClass={"form-control"}
            dropdownTitle={t("common.user.student") || "학생"}
            required={true}
            highLight={validateInput?.user}
          />
          <input
            readOnly
            type="text"
            className="input-like-span p-1"
            value={filters.selectedStudent || ""}
          />
        </div>
        <div className="col">
          <DropdownUniqueUsersInDisplayData
            displayData={teacherData}
            displayKey={"fullname"}
            valueKey={"username"}
            uniqueKey={"username"}
            sortKey={"fullname"}
            isDesc={false}
            handleDropdownChange={handleDropdownChange}
            selectedUser={filters.selectedTeacher}
            selectName={"teacher"}
            styleClass={"form-control"}
            dropdownTitle={"관찰자"}
            required={true}
            highLight={validateInput?.teacher}
          />
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-auto">
          <AddInputsRow
            inputData={inputData}
            handleCreateInputChange={handleCreateInputChange}
            handleCreateAction={handleCreateAction}
            dataToCreate={dataToCreate}
            styleClass="form-control p-1 m-0"
            btnStyleClass="btn btn-primary"
            entireClass="col-auto d-flex align-items-top"
            displayMapping={displayMapping}
          />
        </div>
      </div>
      <div className="row mt-3">
        {dataToSave.length > 0 &&
        !hasPermission(
          null,
          "can_read",
          checkHrteachers(
            hrTeachersData,
            dataToSave[0].username,
            filters.schoolYear,
          ),
        ) ? (
          <SimpleAlertMessageBlock
            message={t("common.messages.homeroomAccessOnly")}
          />
        ) : (
          <div className="col" style={{ minWidth: "800px", overflowX: "auto" }}>
            <SaveInputsTable
              organSettingInfo={filters}
              inputData={inputData}
              userInputDataList={
                filters.selectedStudent
                  ? dataToSave.filter(
                      (r) => r.username === filters.selectedStudent,
                    )
                  : dataToSave
              }
              handleSaveState={handleSaveState}
              handleSaveClick={handleSaveClick}
              handleDelete={handleDelete}
              handleConfirmDelete={handleConfirmDelete}
              handleCancelDelete={handleCancelDelete}
              confirmDelete={confirmDelete}
              savedRows={savedRows}
              addfontSize="+2"
              addMinWidth=""
              groupOp={false}
              groupName=""
              displayMapping={displayMapping}
              handleSaveAll={handleSaveAll}
              savedBulk={savedBulk}
              // 정렬 기능 활성화
              sortable={true}
              exportable={true}
              exportFileName="PEP관찰기록"
              exportButtonLabel="To Excel"
            />
          </div>
        )}
      </div>
    </>
  );
}
